import React from "react";

const STATUS_COLORS = {
  Open: { bg: "#E6EAEE", text: "#5C7080" },
  "In Progress": { bg: "#F5EBDA", text: "#A67C3D" },
  Completed: { bg: "#E8EDE3", text: "#5B7355" },
  Cancelled: { bg: "#EFEBE4", text: "#8B8278" },
};

const PRIORITY_COLORS = {
  High: { bg: "#F3E2DA", text: "#A85A3C" },
  Medium: { bg: "#F5EBDA", text: "#A67C3D" },
  Low: { bg: "#E6EAEE", text: "#5C7080" },
};

const LINK_COLORS = {
  Asset: { bg: "#E3EAF2", text: "#3D6195" },
  Lead: { bg: "#EAE3F2", text: "#6A4D95" },
  Broker: { bg: "#E3F2EC", text: "#2F7D63" },
};

function Pill({ map, value, testid }) {
  const c = map[value] || { bg: "#EFEBE4", text: "#8B8278" };
  return (
    <span
      style={{ backgroundColor: c.bg, color: c.text }}
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold"
      data-testid={testid}
    >
      {value}
    </span>
  );
}

export function TaskStatusBadge({ status }) {
  return <Pill map={STATUS_COLORS} value={status} testid={`task-status-${String(status).toLowerCase().replace(/\s+/g, "-")}`} />;
}

export function TaskPriorityBadge({ priority }) {
  return <Pill map={PRIORITY_COLORS} value={priority} testid={`task-priority-${String(priority).toLowerCase()}`} />;
}

export function LinkTypeChip({ type }) {
  const c = LINK_COLORS[type] || { bg: "#EFEBE4", text: "#8B8278" };
  return (
    <span
      style={{ backgroundColor: c.bg, color: c.text }}
      className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide"
    >
      {type}
    </span>
  );
}
